import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Auth.css';
import { useContainerScale } from './hooks/useViewportScale';

function GoogleCallback({ setUser }) {
  const navigate = useNavigate();
  const location = useLocation();
  const processedRef = useRef(false);
  
  // Viewport scaling for responsive design
  const { 
    scale: viewportScale, 
    offsetX: viewportOffsetX, 
    offsetY: viewportOffsetY,
    baseWidth: containerBaseWidth,
    baseHeight: containerBaseHeight,
    isMobile: isContainerMobile
  } = useContainerScale();

  useEffect(() => {
    console.log('🔄 GoogleCallback component mounted');
    console.log('   Current URL:', window.location.href);
    console.log('   Location pathname:', location.pathname);
    console.log('   Location hash:', location.hash);
    console.log('   Search params:', window.location.search);
    console.log('   Already processed:', processedRef.current);
    
    // Read parameters first to check if we have tokens
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const refreshToken = urlParams.get('refreshToken');
    const userId = urlParams.get('userId');
    const username = urlParams.get('username');

    console.log('   Extracted params:', {
      hasToken: !!token,
      hasRefreshToken: !!refreshToken,
      hasUserId: !!userId,
      hasUsername: !!username,
      tokenPreview: token ? token.substring(0, 20) + '...' : 'none',
      userId: userId,
      username: username
    });

    // CRITICAL: Only process if we have tokens AND we're on the callback route
    // If no tokens, this is likely a re-render after navigation - just return silently
    if (!token || !userId || !username) {
      console.log('   ⚠️ No tokens in URL - skipping (likely re-render after navigation)');
      return;
    }

    // Prevent processing if we've already handled this callback
    if (processedRef.current) {
      console.log('   ⚠️ Already processed, skipping');
      return;
    }
    
    // Only process if we're actually on the callback route
    const isCallbackRoute = location.pathname === '/auth/google/callback' || 
                            window.location.pathname === '/auth/google/callback' ||
                            (location.hash && location.hash.includes('/auth/google/callback'));
    
    if (!isCallbackRoute) {
      console.log('   ⚠️ Not on callback route, skipping processing');
      return;
    }

    // Mark as processed BEFORE doing anything that might cause re-renders
    processedRef.current = true;
    
    console.log('✅ All required params present - storing tokens and navigating');
    localStorage.setItem('token', token);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('user', decodeURIComponent(username));
    localStorage.setItem('userId', userId);
    setUser({ username: decodeURIComponent(username), userId: parseInt(userId) });
    console.log('✅ User state updated, navigating to /welcome');
    navigate('/welcome', { replace: true }); // Use replace to prevent back button issues
  }, [navigate, setUser, location.pathname, location.hash]);

  return (
    <div className="auth-viewport-wrapper">
      <div className="auth-fullscreen-background" />
      <div 
        className="auth-viewport-container"
        style={{
          width: `${containerBaseWidth}px`,
          height: `${containerBaseHeight}px`,
          transformOrigin: '0 0',
          transform: `translate(${viewportOffsetX}px, ${viewportOffsetY}px) scale(${viewportScale})`,
        }}
      >
        <div className={`auth-container ${isContainerMobile ? 'auth-mobile' : ''}`}>
          <div className="auth-card">
            <h1 className="auth-title">Completing Sign In...</h1>
            <div className="auth-message">
              <p>Please wait while we complete your authentication...</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GoogleCallback;

